/**
 * src/modules/dashboard/componentes/feedbackprodutos.js
 * -----------------------------------------------------------------------------
 * Componente para exibir feedbacks por produto.
 * - Recebe dados via props.
 * - Exibe filtros aplicados no topo.
 * - Usa ícones para o canal.
 */

import React from 'react';
import './feedbackprodutos.scss';

// ícones PNG do canal
import gmbIcon from '../../comentnovo/listwithicon/iconimages/gmb.png';
import facebookIcon from '../../comentnovo/listwithicon/iconimages/facebook.png';
import instagramIcon from '../../comentnovo/listwithicon/iconimages/instagram.png';
import tiktokIcon from '../../comentnovo/listwithicon/iconimages/tiktok.png';
import tripadvisorIcon from '../../comentnovo/listwithicon/iconimages/tripadvisor.png';
import youtubeIcon from '../../comentnovo/listwithicon/iconimages/youtube.png';
import twitterIcon from '../../comentnovo/listwithicon/iconimages/twitter.png';
import amazonIcon from '../../comentnovo/listwithicon/iconimages/amazon.png';

const canalIcons = [
  { match: 'google', icon: gmbIcon },
  { match: 'gmb', icon: gmbIcon },
  { match: 'facebook', icon: facebookIcon },
  { match: 'instagram', icon: instagramIcon },
  { match: 'tiktok', icon: tiktokIcon },
  { match: 'tripadvisor', icon: tripadvisorIcon },
  { match: 'youtube', icon: youtubeIcon },
  { match: 'twitter', icon: twitterIcon },
  { match: 'amazon', icon: amazonIcon },
];

function IconCanal({ canal }) {
  if (!canal) return <span>—</span>;
  const key = canal.toLowerCase();
  const found = canalIcons.find(c => key.includes(c.match));
  return found ? <img src={found.icon} alt={canal} className="canal-ico" /> : <span>{canal}</span>;
}

export default function FeedbackProdutos({
  title,
  escopo,
  items = [],
  nls = {},          // ← nls global (para "filtrosAplicados")
  componentNls = {}, // ← nls do tópico (vem de payload.nls)
  autor,
  filtros = [],
  totaldata
}) {
  return (
    <>
    <section className="box-comentarios box-content-like">
      {/* Filtros aplicados */}
      {filtros.length > 0 && (
        <div className="feedback-filtros-aplicados">
          <p className="filtros-label">{nls?.filtrosAplicados || 'Filtros aplicados'}:</p>
          <ul className="filtros-lista">
            {filtros.map((filtro, idx) => (
              <li key={idx} className="filtro-item">
                <strong>{filtro.nomedofiltro}:</strong> {filtro.valordofiltro}
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="box-comentarios-tabela">
        <table className="tabela-comentarios">
          <thead>
            <tr>
              <th className="th-produto">{componentNls?.produto || 'Produto'}</th>
              <th className="th-comentario">{componentNls?.comentario || 'Comentário'}</th>
              <th className="th-canal">{componentNls?.canal || 'Canal'}</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan={3} className="fl-empty">
                  {componentNls?.semdadosparaexibir || 'Sem dados para exibir'}
                </td>
              </tr>
            ) : (
              items.map((r, i) => (
                <tr key={i} className="row-hoverable">
                  <td className="col-produto">{r.produto || '—'}</td>
                  <td className="col-comentario">{r.comentario}</td>
                  <td className="col-canal"><IconCanal canal={r.canal} /></td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </section>
    {totaldata !== null && totaldata !== undefined && (
      <div className="feedback-totaldata-outside">
        {nls?.numerodefeedbacks}: <strong>{totaldata}</strong>
      </div>
    )}
  </>
  );
}

/*
JSON NO INPUT:


{
      "nls": {
        "canal": "CHANNEL",
        "comentario": "FEEDBACK",
        "produto": "PRODUCT",
        "semdadosparaexibir": "No data"
      },
      "label": "Feedback por Produto",
      "scope": {
        "periodo": {
          "fim": "2025-08-31",
          "ini": "2025-08-01"
        },
        "projetoId": 24
      },
      "params": {
        "RPP": 7,
        "tipo": "produtos",
        "idiomaId": 1,
        "empresaId": 138,  //NÃO É OBRIGATÓRIO, PODE OMITIR
        "pageNumber": 1,
        "categoriaId": 1   //NÃO É OBRIGATÓRIO, PODE OMITIR
      },
      "Filtros": [
        {
          "nomedofiltro": "Produtos",
          "valordofiltro": "Apple"
        },
        {
          "nomedofiltro": "Categoria",
          "valordofiltro": "Preço"
        }
      ],
      "ordinal": 1,
      "topicKey": "feedbackprodutos"
}



*/
